
// // src/pages/Roles/RoleForm.jsx
// import React, { useState, useEffect } from "react";
// import api from "../../utils/api";

// const modules = [
//   { key: "leads", label: "Leads", actions: ["list", "create", "edit", "delete"] },
//   { key: "quotations", label: "Quotations", actions: ["list", "create", "edit", "approve"] },
//   { key: "tasks", label: "Tasks", actions: ["list", "create", "assign", "complete"] },
//   { key: "prospects", label: "Prospects", actions: ["list", "view"] },
//   { key: "workflow", label: "Workflow", actions: ["view", "manage"] },
//   // { key: "staff", label: "Staff Management", actions: ["list", "create", "edit", "delete"] },
//   // { key: "roles", label: "Role Management", actions: ["list", "create", "edit", "delete"] },
//   { key: "settings", label: "Settings", actions: ["view"] },
//   { key: "staff_management", label: "Staff Management", actions: ["list", "create", "edit", "delete"] },
//   { key: "role_management", label: "Role Management", actions: ["list", "create", "edit", "delete"] },
//   { key: "team_management", label: "Team Management", actions: ["list", "create", "edit"] },
//   { key: "project_management", label: "Project Management", actions: ["list", "create", "edit", "delete"] },
// ];
// // const modules = [
// //   { key: "leads", label: "Leads", actions: ["list", "create", "edit", "delete"] },
// //   { key: "quotations", label: "Quotations", actions: ["list", "create", "edit", "approve"] },
// //   { key: "tasks", label: "Tasks", actions: ["list", "create", "assign", "complete"] },
// //   { key: "prospects", label: "Prospects", actions: ["list", "view"] },
// //   { key: "workflow", label: "Workflow", actions: ["view", "manage"] },
// //   { key: "staff_management", label: "Staff Management", actions: ["list", "create", "edit", "delete"] },
// //   { key: "role_management", label: "Role Management", actions: ["list", "create", "edit", "delete"] },
// //   { key: "settings", label: "Settings", actions: ["view"] },
// // ];

// export default function RoleForm({ role, onDone, onCancel }) {
//   const [form, setForm] = useState({
//     name: "",
//     caption: "",
//     admin_panel_access: false,
//     permissions: {},
//   });

//   useEffect(() => {
//     if (role) {
//       setForm({
//         name: role.name || "",
//         caption: role.caption || "",
//         admin_panel_access: role.admin_panel_access || false,
//         permissions: role.permissions || {},
//       });
//     }
//   }, [role]);

// //   useEffect(() => {
// //   if (role) {
// //     let normalizedPermissions = { ...role.permissions };

// //     // Convert old keys to new ones (backward compatibility)
// //     if (normalizedPermissions.staff) {
// //       normalizedPermissions.staff_management = normalizedPermissions.staff;
// //       delete normalizedPermissions.staff;
// //     }
// //     if (normalizedPermissions.roles) {
// //       normalizedPermissions.role_management = normalizedPermissions.roles;
// //       delete normalizedPermissions.roles;
// //     }

// //     setForm({
// //       name: role.name || "",
// //       caption: role.caption || "",
// //       admin_panel_access: role.admin_panel_access || false,
// //       permissions: normalizedPermissions,
// //     });
// //   }
// // }, [role]);

// const handlePermissionChange = (moduleKey, action) => {
//   setForm((prev) => {
//     const current = prev.permissions[moduleKey] || [];
//     let newActions;

//     if (current.includes(action)) {
//       newActions = current.filter(a => a !== action); // uncheck
//     } else {
//       newActions = [...current, action]; // check
//     }

//     // Remove empty arrays to keep JSON small
//     const newPermissions = { ...prev.permissions };
//     if (newActions.length === 0) {
//       delete newPermissions[moduleKey];
//     } else {
//       newPermissions[moduleKey] = newActions;
//     }

//     return {
//       ...prev,
//       permissions: newPermissions
//     };
//   });
// };
//   // const handlePermissionChange = (moduleKey, action) => {
//   //   setForm((prev) => ({
//   //     ...prev,
//   //     permissions: {
//   //       ...prev.permissions,
//   //       [moduleKey]: {
//   //         ...prev.permissions[moduleKey],
//   //         [action]: !(prev.permissions[moduleKey]?.[action] ?? false),
//   //       },
//   //     },
//   //   }));
//   // };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       if (role) {
//         await api.put(`/roles/${role.id}`, form);
//       } else {
//         await api.post("/roles", form);
//       }
//       onDone();
//     } catch (err) {
//       alert(err?.response?.data?.message || "Failed to save role");
//     }
//   };

//   return (
//     <div className="bg-white rounded-2xl shadow-2xl p-10 border border-gray-200">
//       <h2 className="text-3xl font-bold text-gray-900 mb-10">
//         {role ? "Edit Role" : "New Role"}
//       </h2>

//       <form onSubmit={handleSubmit} className="space-y-8">
//         {/* Name */}
//         <div>
//           <label className="block text-sm font-semibold text-gray-700 mb-2">
//             Name <span className="text-red-500">*</span>
//           </label>
//           <input
//             type="text"
//             required
//             value={form.name}
//             onChange={(e) => setForm({ ...form, name: e.target.value.replace(/\s/g, "_") })}
//             className="w-full px-6 py-4 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500"
//             placeholder="Finance_Staff"
//           />
//           <p className="text-sm text-gray-500 mt-2">
//             Use underscore (_) to separate words. Must be unique.
//           </p>
//         </div>

//         {/* Caption */}
//         <div>
//           <label className="block text-sm font-semibold text-gray-700 mb-2">Caption</label>
//           <input
//             type="text"
//             value={form.caption}
//             onChange={(e) => setForm({ ...form, caption: e.target.value })}
//             className="w-full px-6 py-4 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500"
//             placeholder="Financial Staff"
//           />
//         </div>

//         {/* Admin Access */}
//         <div className="flex items-center gap-4">
//           <input
//             type="checkbox"
//             id="admin"
//             checked={form.admin_panel_access}
//             onChange={(e) => setForm({ ...form, admin_panel_access: e.target.checked })}
//             className="w-6 h-6 text-orange-500 rounded focus:ring-orange-500"
//           />
//           <label htmlFor="admin" className="text-lg font-medium text-gray-800 cursor-pointer">
//             Admin Panel Access
//           </label>
//         </div>

//         {/* Permissions */}
//         <div>
//           <h3 className="text-2xl font-bold text-orange-600 mb-4">Permissions</h3>
//           <p className="text-gray-600 mb-8">
//             Select menus, sub-menus, and actions to assign permissions.
//           </p>

//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//             {modules.map((mod) => (
//               <div key={mod.key} className="bg-gray-50 rounded-xl p-6 border border-gray-200 hover:border-orange-400 transition">
//                 <h4 className="font-bold text-gray-900 mb-5 flex items-center gap-3">
//                   <input type="checkbox" disabled checked className="text-orange-500" />
//                   {mod.label}
//                 </h4>
//                 <div className="space-y-4">
//                   {mod.actions.map((action) => (
//                     <label key={action} className="flex items-center gap-4 cursor-pointer">
//                       <input
//                         type="checkbox"
//                         checked={Array.isArray(form.permissions[mod.key]) && form.permissions[mod.key].includes(action)}
//                         onChange={() => handlePermissionChange(mod.key, action)}
//                         className="w-5 h-5 text-orange-500 rounded focus:ring-orange-500"
//                       />
//                       <span className="text-gray-700 capitalize">{action}</span>
//                     </label>
//                   ))}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Buttons */}
//         <div className="flex gap-6 pt-8">
//           <button
//             type="submit"
//             className="px-10 py-4 bg-[#0f172a] hover:bg-orange-600 text-white font-bold rounded-xl shadow-lg transition"
//           >
//             {role ? "Update" : "Create"}
//           </button>
//           <button
//             type="button"
//             onClick={onCancel}
//             className="px-10 py-4 bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold rounded-xl transition"
//           >
//             Cancel
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// }

// src/pages/Roles/RoleForm.jsx
import React, { useState, useEffect } from "react";
import api from "../../utils/api";

const modules = [
  { key: "leads", label: "Leads", actions: ["list", "create", "edit", "delete"] },
  { key: "quotations", label: "Quotations", actions: ["list", "create", "edit", "approve"] },
  { key: "tasks", label: "Tasks", actions: ["list", "create", "assign", "complete"] },
  { key: "prospects", label: "Prospects", actions: ["list", "view"] },
  { key: "workflow", label: "Workflow", actions: ["view", "manage"] },
  { key: "staff_management", label: "Staff Management", actions: ["list", "create", "edit", "delete"] },
  { key: "role_management", label: "Role Management", actions: ["list", "create", "edit", "delete"] },
  { key: "team_management", label: "Team Management", actions: ["list", "create", "edit"] },
  { key: "project_management", label: "Project Management", actions: ["list", "create", "edit", "delete"] },
  { key: "settings", label: "Settings", actions: ["view"] },
];

export default function RoleForm({ role, onDone, onCancel, mode = "light" }) {
  const isDark = mode === "dark";

  const [form, setForm] = useState({
    name: "",
    caption: "",
    admin_panel_access: false,
    permissions: {},
  });

  useEffect(() => {
    if (role) {
      setForm({
        name: role.name || "",
        caption: role.caption || "",
        admin_panel_access: role.admin_panel_access || false,
        permissions: role.permissions || {},
      });
    }
  }, [role]);

  const handlePermissionChange = (moduleKey, action) => {
    setForm((prev) => {
      const current = prev.permissions[moduleKey] || [];
      let newActions;

      if (current.includes(action)) {
        newActions = current.filter((a) => a !== action);
      } else {
        newActions = [...current, action];
      }

      const newPermissions = { ...prev.permissions };
      if (newActions.length === 0) {
        delete newPermissions[moduleKey];
      } else {
        newPermissions[moduleKey] = newActions;
      }

      return {
        ...prev,
        permissions: newPermissions,
      };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (role) {
        await api.put(`/roles/${role.id}`, form);
      } else {
        await api.post("/roles", form);
      }
      onDone();
    } catch (err) {
      alert(err?.response?.data?.message || "Failed to save role");
    }
  };

  return (
    <div
      className={`rounded-2xl shadow-2xl p-10 border ${
        isDark ? "bg-slate-800 border-slate-700" : "bg-white border-gray-200"
      }`}
    >
      <h2 className={`text-3xl font-bold mb-10 ${isDark ? "text-white" : "text-gray-900"}`}>
        {role ? "Edit Role" : "New Role"}
      </h2>

      <form onSubmit={handleSubmit} className="space-y-8">
        {/* Name */}
        <div>
          <label className={`block text-sm font-semibold mb-2 ${isDark ? "text-slate-300" : "text-gray-700"}`}>
            Name <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            required
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value.replace(/\s/g, "_") })}
            className={`w-full px-6 py-4 border rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 transition ${
              isDark
                ? "bg-slate-700 border-slate-600 text-white placeholder-slate-400"
                : "bg-white border-gray-300 text-gray-900 placeholder-gray-400"
            }`}
            placeholder="Finance_Staff"
          />
          <p className={`text-sm mt-2 ${isDark ? "text-slate-400" : "text-gray-500"}`}>
            Use underscore (_) to separate words. Must be unique.
          </p>
        </div>

        {/* Caption */}
        <div>
          <label className={`block text-sm font-semibold mb-2 ${isDark ? "text-slate-300" : "text-gray-700"}`}>
            Caption
          </label>
          <input
            type="text"
            value={form.caption}
            onChange={(e) => setForm({ ...form, caption: e.target.value })}
            className={`w-full px-6 py-4 border rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 transition ${
              isDark
                ? "bg-slate-700 border-slate-600 text-white placeholder-slate-400"
                : "bg-white border-gray-300 text-gray-900 placeholder-gray-400"
            }`}
            placeholder="Financial Staff"
          />
        </div>

        {/* Admin Access */}
        <div className="flex items-center gap-4">
          <input
            type="checkbox"
            id="admin"
            checked={form.admin_panel_access}
            onChange={(e) => setForm({ ...form, admin_panel_access: e.target.checked })}
            className="w-6 h-6 text-orange-500 rounded focus:ring-orange-500"
          />
          <label
            htmlFor="admin"
            className={`text-lg font-medium cursor-pointer ${isDark ? "text-slate-200" : "text-gray-800"}`}
          >
            Admin Panel Access
          </label>
        </div>

        {/* Permissions */}
        <div>
          <h3 className={`text-2xl font-bold mb-4 ${isDark ? "text-orange-400" : "text-orange-600"}`}>
            Permissions
          </h3>
          <p className={`mb-8 ${isDark ? "text-slate-400" : "text-gray-600"}`}>
            Select menus, sub-menus, and actions to assign permissions.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {modules.map((mod) => (
              <div
                key={mod.key}
                className={`rounded-xl p-6 border transition ${
                  isDark
                    ? "bg-slate-700 border-slate-600 hover:border-orange-500/50"
                    : "bg-gray-50 border-gray-200 hover:border-orange-400"
                }`}
              >
                <h4 className={`font-bold mb-5 flex items-center gap-3 ${isDark ? "text-white" : "text-gray-900"}`}>
                  <input type="checkbox" disabled checked className="text-orange-500" />
                  {mod.label}
                </h4>
                <div className="space-y-4">
                  {mod.actions.map((action) => (
                    <label key={action} className="flex items-center gap-4 cursor-pointer">
                      <input
                        type="checkbox"
                        checked={Array.isArray(form.permissions[mod.key]) && form.permissions[mod.key].includes(action)}
                        onChange={() => handlePermissionChange(mod.key, action)}
                        className="w-5 h-5 text-orange-500 rounded focus:ring-orange-500"
                      />
                      <span className={`${isDark ? "text-slate-300" : "text-gray-700"} capitalize`}>{action}</span>
                    </label>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Buttons */}
        <div className="flex gap-6 pt-8">
          <button
            type="submit"
            className={`px-10 py-4 font-bold rounded-xl shadow-lg transition ${
              isDark ? "bg-slate-800 hover:bg-orange-600 text-white" : "bg-[#0f172a] hover:bg-orange-600 text-white"
            }`}
          >
            {role ? "Update" : "Create"}
          </button>
          <button
            type="button"
            onClick={onCancel}
            className={`px-10 py-4 font-bold rounded-xl transition ${
              isDark ? "bg-slate-700 hover:bg-slate-600 text-slate-200" : "bg-gray-300 hover:bg-gray-400 text-gray-800"
            }`}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}